import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo, faX } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { CreditCardsService } from '../../../services/bidder-community/credit-cards/credit-cards.service';
import { ICreditCardDTO } from '../../../models/ICreditCardDTO';
import { AuthService } from '../../../services/authentication/auth.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ShippingAddressService } from '../../../services/bidder-community/shipping-address/shipping-address.service';
import { IShippingAddressDTO } from '../../../models/IShippingAddressDTO ';
import { IAccountInfoDTO } from '../../../models/IAccountInfoDTO';
import { AccountInfoService } from '../../../services/bidder-community/account-info/account-info.service';

@Component({
  selector: 'app-welcome-back',
  imports: [CommonModule, DynamicDialogModule, FaIconComponent, ButtonModule],
  templateUrl: './welcome-back.component.html',
  styleUrl: './welcome-back.component.scss'
})
export class WelcomeBackComponent implements OnInit{

  private readonly creditCardsService = inject(CreditCardsService);
  private readonly authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly shippingAddressService = inject(ShippingAddressService);
  private readonly accountService = inject(AccountInfoService);

  faCircleInfo = faCircleInfo;
  faXmark = faX;

  creditCardsList: ICreditCardDTO[] | null = null;
  shippingAddressInfo: IShippingAddressDTO | null = null;
  accountInfo: IAccountInfoDTO | null = null;

  isAuthenticated = this.oidcSecurityService.authenticated;
  authSubscription!: Subscription;

  constructor(private router: Router){}


  ngOnInit(): void {

    if(this.shouldShowWelcomeBack()){
      this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
        if (isAuth) {
          this.getAccountInfo();
          this.getShippingAddressInfo();
          this.getCreditCardsList();
        }
      });
    }else{
      this.close();
    }
    
  }

  close!: () => void;
  
  onReject(){
    this.close();
    this.router.navigate(['/my-account' ]);
  }

  getAccountInfo() {
    this.accountService.getAccountInfo().subscribe(({
      next: () => {
        this.accountInfo = this.accountService.accountInfoSignal();
      },
      error: (err) => {
        console.log('Error retreve data', err);
      }
    }))
  }

  getShippingAddressInfo() {
    this.shippingAddressService.getShippingAddressInfo().subscribe(({
      next: () => {
        this.shippingAddressInfo = this.shippingAddressService.shippingAddressInfoSignal();
      },
      error: (err) => {
        console.error('Error retreve data', err);
      },
    }))
  }

  getCreditCardsList() {
    this.creditCardsService.getCreditCards().subscribe(({
      next: () => {
        this.creditCardsList = this.creditCardsService.creditCardsListSignal();
      },
      error: (err) => {
        console.log('Error retrieve data', err);
      }
    }))
  }

  getFullName(){
    return this.accountInfo!.firstName + " " + this.accountInfo!.lastName;
  }

  shouldShowWelcomeBack(){
    var today = new Date();
    var lastLogin = new Date(this.oidcSecurityService.userData().userData.bfg_previous_login);
    var millisecondsDiff = today.getTime() - lastLogin.getTime();
    var daysDiff = Math.floor(millisecondsDiff / (1000 * 60 * 60 * 24));
    return daysDiff >= 60;
  }

}
